import pjson from './../package.json';

export const OKTA_DOMAIN = process.env.REACT_APP_OKTA_DOMAIN;
export const OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const API_REPORTS = process.env.REACT_APP_API_REPORTS;
export const VERSION = pjson.version;
